import { useQuery } from '@apollo/client/react';
import { Preferences } from '@drycut/booking-components';
import { type BasicCustomerFragment, GetCustomerDocument, type Maybe } from '@drycut/graphql';
import { Loader } from '@drycut/ui-components';
import { useNavigate, useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

export function CustomerPreferences(): React.ReactNode {
  useDocumentTitle('DRYCUT - Preferences');

  const navigate = useNavigate();
  const { code } = useParams() as { code: string };
  const { data, loading } = useQuery(GetCustomerDocument, { variables: { code } });

  const customer: Maybe<BasicCustomerFragment> = data?.customer || null;

  if (loading) {
    return <Loader />;
  }

  if (!customer) {
    navigate('/not-found');
    return null;
  }

  return <Preferences customer={customer} />;
}
